const getMdd = (device, spd) => {
  return { key: device, value: device, text: device, msettings: { w: spd.viewportWidth, h: spd.viewportHeight } }
}

export const parentStyleOptions = () => {
  const psos = []
  psos.push({ key: 'home', value: 'home', text: 'home' })
  psos.push({ key: 'client', value: 'client', text: 'client' })
  psos.push({ key: 'event', value: 'event', text: 'event' })
  return psos
}

export const mobileDeviceTypes = () => {
  const devices = []
  Object.keys(smartphoneDimensions).forEach(key => {
    const spd = smartphoneDimensions[key]
    devices.push(getMdd(key, spd))
  })
  return devices
}

export const smartPhoneTypes = {
  desktop: 'desktop',
  desktopMobile: 'desktopMobile',
  smartphone: 'smartphone',
  tablet: 'tablet',
}

export const smartphoneDimensions = {
  desktop: {
    key: "desktop",
    manufacturer: "None",
    viewportWidth: '84vw',
    viewportHeight: '95vh'
  },
  desktopMobile: {
    key: "desktopMobile",
    manufacturer: "None",
    viewportWidth: '84vw',
    viewportHeight: '95vh'
  },
  smartphone: {
    key: "smartphone",
    manufacturer: "None",
    viewportWidth: 440,
    viewportHeight: 800
  },
  tablet: {
    key: "tablet",
    manufacturer: "None",
    viewportWidth: '88vh',
    viewportHeight: '68vh'
  },
};
